import { render, staticRenderFns } from "./WaterControl.vue?vue&type=template&id=d9c1ce04&scoped=true&"
import script from "./WaterControl.vue?vue&type=script&lang=js&"
export * from "./WaterControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c1ce04",
  null
  
)

export default component.exports